var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "item-text": "key",
      "item-value": "key",
      label: _vm.label,
      disabled: _vm.disabled,
      clearable: _vm.clearable,
      loading: _vm.loading,
      "return-object": "",
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }